export default () => {
    const sessionToken = localStorage.getItem("sb");
    try {
        if (sessionToken != null) {
            const jwtDecode = require('jwt-decode');
            const decoded = jwtDecode(sessionToken);
            var authUser = JSON.parse(decoded.sub);
            authUser['sessionToken'] = sessionToken;
            return authUser;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}